import _ from 'underscore';

import { AssetEventOperationName, AssetEventRecordType, POST_ASSET_EVENT_NAME } from './constants';

export const prefillAssetsAppliedLog = (CampaignId, initialSuggestionsData) => {
  const Properties = _.keys(initialSuggestionsData);
  const PrefilledSuggestionsCount = _.map(Properties, propertyName => initialSuggestionsData[propertyName].prefilledCount);
  const AppliedPrefilledSuggestionsCount = _.map(Properties, propertyName => _.size(initialSuggestionsData[propertyName].remainingSuggestions));

  return ({
    EventName: POST_ASSET_EVENT_NAME,
    EventValue: {
      RecordType: AssetEventRecordType.APPLIED,
      OperationName: AssetEventOperationName.PREFILL,
      CampaignId,
      Properties,
      PrefilledSuggestionsCount,
      AppliedPrefilledSuggestionsCount,
    },
  });
};
